import React from 'react';

export const PostSkeleton = () => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[2.5rem] shadow-sm border border-slate-200/60 dark:border-slate-700/50 overflow-hidden mb-8">
      <div className="p-4 flex items-center gap-3">
        <div className="h-10 w-10 rounded-full shimmer" />
        <div className="space-y-2">
          <div className="h-4 w-32 shimmer rounded-md" />
          <div className="h-3 w-20 shimmer rounded-md opacity-60" />
        </div>
      </div>
      
      <div className="px-4 pb-3 space-y-2">
        <div className="h-4 w-full shimmer rounded-md opacity-40" />
        <div className="h-4 w-2/3 shimmer rounded-md opacity-40" />
      </div>

      <div className="aspect-square sm:aspect-video shimmer sm:mx-4 sm:rounded-2xl mb-4" />

      <div className="p-4 flex gap-6 border-t border-slate-50 dark:border-slate-700/50">
        <div className="h-6 w-12 shimmer rounded-full opacity-60" />
        <div className="h-6 w-12 shimmer rounded-full opacity-60" />
      </div>
    </div>
  );
};
